(function ($, Drupal) {
  'use strict';

  // global vars
  var medium = 641;
  var desktop = 1024;

  Drupal.behaviors.nsbParallax = {
    attach: function (context, settings) {
    }
  };

  $(document).ready(function () {
    var allScrollElements = $(".parallax");
    var scrollTop = $(this).scrollTop();
    setParallaxElements(allScrollElements, scrollTop);
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      setParallaxElements(allScrollElements, scrollTop);
    });
  });

  function setParallaxElements(allScrollElements, scrollTop){
    allScrollElements.each(function (i, e) {
      var _that = $(this);
      var offset = _that.attr('data-offset');
      var positionTop = _that.offset().top;
      if(positionTop < 0){
        positionTop = 0;
      }
      var moveBy = offset * (positionTop - scrollTop) / 1000;
      _that.css({
        "transform": "translateY(" + moveBy + "px)"
      });
    });
  }

})(jQuery, Drupal);